import _ from 'lodash';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { IUserInfo } from 'types';

import { useToast } from '@chakra-ui/react';
import { useMultiLanguagesHandler } from 'contexts/MultiLanguagesContext';
import tabsMapper from 'router/tabsMapper';

const TRANSLATIO_URL = process.env.REACT_APP_TRANSLATIO_URL as string;

type NotificationType = {
    key: string;
    country: string | null;
    enabled: boolean;
    en: string;
    fr: string;
    page: number | null;
    type: 'warning' | 'info' | 'error';
};
const useNotifications = (client?: IUserInfo) => {
    const { locale } = useMultiLanguagesHandler();

    const toast = useToast();
    const [notifications, setNotifications] = useState<NotificationType[]>([]);

    const location = useLocation();

    useEffect(() => {
        if (!client) return;

        fetch(`${TRANSLATIO_URL}/notifications.json`)
            .then((res) => res.json())
            .then((data) => {
                const notificationsList: NotificationType[] = _.map(_.values(data), (v) => _.values(v).flat())
                    .flat()
                    .filter((item) => item?.enabled);

                setNotifications(notificationsList);
            })
            .catch((err) => {
                console.error(err);
            });
    }, [client]);

    useEffect(() => {
        if (!client) return;

        const formattedPath = location.pathname?.endsWith('/') ? location.pathname.slice(0, -1) : location.pathname;
        const page = tabsMapper[formattedPath];

        const [globalNotifications, globalNotificationsToHide] = _.partition(
            notifications,
            (item) => (!item.country || String(client.country.id) === item.country) && item.page === 9090,
        );

        globalNotificationsToHide.forEach((item) => {
            if (toast.isActive(item.key)) {
                toast.close(item.key);
            }
        });

        globalNotifications.forEach((item) => {
            if (!toast.isActive(item.key)) {
                toast({
                    title: item[locale as 'en' | 'fr'],
                    status: item.type,
                    isClosable: true,
                    duration: null,
                    id: item.key,
                    position: 'top',
                });
            }
        });

        if (!page) return;

        const pageId = page.id;

        notifications
            .filter(
                (item) => [null, `${client.country.id}`].includes(item.country) && [null, pageId].includes(item.page),
            )
            .forEach((item) => {
                if (!toast.isActive(item.key)) {
                    toast({
                        title: item[locale as 'en' | 'fr'],
                        status: item.type,
                        isClosable: true,
                        duration: null,
                        id: item.key,
                        position: 'top',
                    });
                }
            });
    }, [toast, client, notifications, location.pathname, locale]);

    return null;
};

export default useNotifications;
